import React from "react";

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Sarah Chen",
      role: "DeFi Investor",
      company: "Green Crypto Fund",
      content: "X EcoChain's energy efficiency is revolutionary. We've reduced our carbon footprint by 85% while maintaining top-tier security.",
      avatar: "https://images.unsplash.com/photo-1494790108755-2616b786d4d7?w=150&h=150&fit=crop&crop=face",
      rating: 5
    },
    {
      id: 2,
      name: "Marcus Rodriguez",
      role: "Blockchain Developer",
      company: "Web3 Studio",
      content: "The developer experience is exceptional. Fast transactions, low fees, and incredible documentation made migration seamless.",
      avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
      rating: 5
    },
    {
      id: 3,
      name: "Dr. Emily Watson",
      role: "Sustainability Researcher",
      company: "MIT Digital Currency",
      content: "Finally, a blockchain that aligns with environmental goals. X EcoChain proves that sustainability and innovation can coexist.",
      avatar: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=face",
      rating: 5
    },
    {
      id: 4,
      name: "Alex Thompson",
      role: "NFT Artist",
      company: "Digital Art Collective",
      content: "Creating and trading eco-friendly NFTs has never been easier. The community and technology are both outstanding.",
      avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
      rating: 5
    },
    {
      id: 5,
      name: "Jessica Park",
      role: "Crypto Journalist",
      company: "Blockchain Weekly",
      content: "X EcoChain sets the standard for green blockchain technology. Their transparency and commitment to sustainability is unmatched.",
      avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
      rating: 5
    },
    {
      id: 6,
      name: "David Kim",
      role: "Enterprise Architect",
      company: "Fortune 500 Company",
      content: "We chose X EcoChain for our corporate blockchain solutions because of their enterprise-grade security and environmental responsibility.",
      avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
      rating: 5
    }
  ];

  const renderStars = (rating) => {
    return "⭐".repeat(rating);
  };

  return (
    <section className="py-20 bg-gradient-to-br from-eco-black to-eco-dark relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-white to-gray-300"></div>
      
      <div className="max-w-7xl mx-auto px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black gradient-text mb-4">
            Trusted by Innovators
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Join thousands of developers, investors, and creators building the future of sustainable Web3
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="glass-card p-6 rounded-3xl border border-white/20 hover:border-white/40 transition-all duration-500 group hover:transform hover:scale-105"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="text-yellow-400 text-lg">
                  {renderStars(testimonial.rating)}
                </div>
                <div className="relative group-hover:scale-110 transition-transform duration-300">
                  <img 
                    src={testimonial.avatar} 
                    alt={`${testimonial.name}, ${testimonial.role}`}
                    className="w-12 h-12 rounded-full object-cover border-2 border-white/30"
                  />
                  <div className="absolute inset-0 rounded-full bg-white opacity-0 group-hover:opacity-10 blur-md transition-opacity duration-300"></div>
                </div>
              </div>

              <p className="text-gray-300 mb-6 leading-relaxed group-hover:text-white transition-colors">
                "{testimonial.content}"
              </p>

              <div className="flex items-center border-t border-gray-700 pt-4">
                <img 
                  src={testimonial.avatar} 
                  alt={`${testimonial.name}, ${testimonial.role}`}
                  className="w-10 h-10 rounded-full object-cover mr-3"
                />
                <div>
                  <h4 className="font-bold text-white group-hover:text-white transition-colors">
                    {testimonial.name}
                  </h4>
                  <p className="text-gray-300 text-sm font-medium">{testimonial.role}</p>
                  <p className="text-gray-400 text-sm">{testimonial.company}</p>
                </div>
              </div>

              <div className="absolute -top-3 -right-3 w-6 h-6 bg-gradient-to-br from-white to-gray-300 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
          <div className="text-center">
            <div className="text-3xl font-black gradient-text">50K+</div>
            <div className="text-gray-400">Active Users</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-black text-white">99.2%</div>
            <div className="text-gray-400">Uptime</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-black text-gray-300">2.4M+</div>
            <div className="text-gray-400">Transactions</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-black text-gray-400">85%</div>
            <div className="text-gray-400">Energy Saved</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;